import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import MetisMenu from "metismenujs/dist/metismenujs";
import { Router, NavigationEnd } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { EventService } from "../../../core/services/event.service";
import { AuthfakeauthenticationService } from "../../../core/services/authfake.service";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { Admin } from "./admin";
import { CUSTOMER, SUPERVISOR } from "./customer";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  menu: any;

  menuItems = [];
  private destroy$ = new Subject<void>();

  @ViewChild("sideMenu") sideMenu: ElementRef;

  constructor(
    private eventService: EventService,
    private router: Router,
    private authService: AuthfakeauthenticationService
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit(): void {
    this.initialize();

    this.authService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.initialize();
    });
  }

  ngAfterViewInit() {
    this.refreshMenuPlugin();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass("mm-active");
    this._removeAllClass("mm-show");
    const links = document.getElementsByClassName("side-nav-link-ref");
    let menuItemEl = null;

    const paths = [];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      paths.push(links[i]["pathname"]);
    }
    const itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }

    if (menuItemEl) {
      menuItemEl.classList.add("active");
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add("mm-active");

        const parent2El = parentEl.parentElement.closest("ul");
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.add("mm-show");
          const parent3El = parent2El.parentElement;

          if (parent3El && parent3El.id !== "side-menu") {
            parent3El.classList.add("mm-active");
            const childAnchor = parent3El.querySelector(".has-arrow");
            const childDropdown = parent3El.querySelector(".has-dropdown");

            if (childAnchor) {
              childAnchor.classList.add("mm-active");
            }
            if (childDropdown) {
              childDropdown.classList.add("mm-active");
            }

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== "side-menu") {
              parent4El.classList.add("mm-show");
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== "side-menu") {
                parent5El.classList.add("mm-active");
                const childanchor = parent5El.querySelector(".is-parent");
                if (childanchor && parent5El.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Initialize
   */
  custId: string = "";
  initialize(): void {
    const userDetails = JSON.parse(sessionStorage.getItem("currentUser") || "{}");
    const user = userDetails?.user;

    if (!user) {
      this.menuItems = [];
      return;
    }

    this.custId = user?.custId;
    const isInterlock = user?.isInterlockConfig === true || user?.isInterlockConfig === "true";
    if (user["role"] == "SUPERADMIN") {
      this.menuItems = Admin;
    } else if (user["role"] === "SUPERUSER") {
      this.menuItems = [
        {
          id: 1,
          label: "Customer Switcher",
          icon: "ri-user-shared-line",
          link: "/oemAdmin",
        },
        {
          id: 2,
          label: "Super Dashboard",
          icon: "ri-dashboard-line",
          link: "/superDashboard",
        },
      ];
    } else if (user["role"] === "CUSTOMER") {
      this.menuItems = CUSTOMER;

      // remove complete if condition for all customers
      if (this.custId === "GUK7F") {
        const baseRemove = ["Program", "Production Planning", "Operator Mapping", "Workorder Management"];
        const removeList = [...baseRemove];
        if (!isInterlock) {
          removeList.unshift("Escalation");
        }
        this.menuItems = this.menuItems.map((item) => {
          if (item.subItems?.length) {
            return {
              ...item,
              subItems: item.subItems.filter((sub) => !removeList.includes(sub.label)),
            };
          }
          return item;
        });
      } else if (this.custId === "BYX43" || this.custId === "TS414FY9") {
        const removeList = ["Job Card Management", "Workorder Management", "Operator Mapping"];
        this.menuItems = this.menuItems.map((item) => {
          if (item.subItems?.length) {
            return {
              ...item,
              subItems: item.subItems.filter((sub) => !removeList.includes(sub.label)),
            };
          }
          return item;
        });
      } else if (this.custId !== "BYX43" && this.custId !== "GUK7F" && this.custId !== "TS414FY9") {
        const removeList = ["Job Card Management", "Workorder Management", "Operator Mapping"];
        if (!isInterlock) {
          removeList.unshift("Escalation");
        }
        this.menuItems = this.menuItems.map((item) => {
          if (item.subItems?.length) {
            return {
              ...item,
              subItems: item.subItems.filter((sub) => !removeList.includes(sub.label)),
            };
          }
          return item;
        });
      }
    } else if (user["role"] === "SUPERVISOR") {
      this.menuItems = SUPERVISOR;
      // remove complete if condition for all customers
      if (this.custId === "GUK7F") {
        const baseRemove = ["Program", "Production Planning", "Workorder Management", "Operator Mapping"];
        const removeList = [...baseRemove];
        if (!isInterlock) {
          removeList.unshift("Escalation");
        }
        this.menuItems = this.menuItems.map((item) => {
          if (item.subItems?.length) {
            return {
              ...item,
              subItems: item.subItems.filter((sub) => !removeList.includes(sub.label)),
            };
          }
          return item;
        });
      } else if (this.custId === "BYX43" || this.custId === "TS414FY9") {
        const removeList = ["Job Card Management", "Workorder Management", "Operator Mapping"];
        this.menuItems = this.menuItems.map((item) => {
          if (item.subItems?.length) {
            return {
              ...item,
              subItems: item.subItems.filter((sub) => !removeList.includes(sub.label)),
            };
          }
          return item;
        });
      } else if (this.custId !== "BYX43" && this.custId !== "GUK7F" && this.custId !== "TS414FY9") {
        const removeList = ["Job Card Management", "Workorder Management", "Operator Mapping"];
        if (!isInterlock) {
          removeList.unshift("Escalation");
        }
        this.menuItems = this.menuItems.map((item) => {
          if (item.subItems?.length) {
            return {
              ...item,
              subItems: item.subItems.filter((sub) => !removeList.includes(sub.label)),
            };
          }
          return item;
        });
      }
    }
    this.refreshMenuPlugin();
    //  else if (user["role"] === "MAINTENANCE") {
    //    this.menuItems = ManinenaceMENU;
    //  } else if (user["role"] === "OPERATOR") {
    //    this.menuItems = OperatorMENU;
    //  } else if (user["role"] === "SUPERADMIN") {
    //    this.menuItems = Admin;
    //  }
  }

  private refreshMenuPlugin(): void {
    if (!this.sideMenu?.nativeElement) {
      return;
    }

    if (this.menu) {
      this.menu.dispose();
    }

    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string) {
    this.eventService.broadcast("changeLayout", layout);
  }

  /**
   * Light sidebar
   */
  lightSidebar() {
    document.body.setAttribute("data-sidebar", "light");
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar-size");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.classList.remove("vertical-collpsed");
  }

  /**
   * Compact sidebar
   */
  compactSidebar() {
    document.body.setAttribute("data-sidebar-size", "small");
    document.body.setAttribute("data-sidebar", "dark");
    document.body.removeAttribute("data-topbar");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.classList.remove("sidebar-enable");
    document.body.classList.remove("vertical-collpsed");
  }

  /**
   * Icon sidebar
   */
  iconSidebar() {
    document.body.classList.add("sidebar-enable");
    document.body.classList.add("vertical-collpsed");
    document.body.setAttribute("data-sidebar", "dark");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.removeAttribute("data-topbar");
  }

  /**
   * Boxed layout
   */
  boxedLayout() {
    document.body.setAttribute("data-keep-enlarged", "true");
    document.body.setAttribute("data-layout-size", "boxed");
    document.body.setAttribute("data-sidebar", "dark");
    document.body.classList.add("vertical-collpsed");
    document.body.classList.remove("sidebar-enable");
    document.body.removeAttribute("data-topbar");
  }

  /**
   * Colored sidebar
   */
  coloredSidebar() {
    document.body.setAttribute("data-sidebar", "colored");
    document.body.removeAttribute("data-sidebar-size");
    document.body.removeAttribute("data-layout-size");
    document.body.classList.remove("vertical-collpsed");
    document.body.removeAttribute("data-topbar");
  }
}
